import React, {useState} from 'react';
import styled from 'styled-components';
import {useTranslation} from 'react-i18next';
import {useLayer} from 'react-laag';

import {btnColorSetup} from '../../elements/button/btn-setup/btnStyling';
import {Btn} from '../../elements/button/btn-type/Btn';
import {Icon} from '../../elements/Icon/Icon';

import {OptionCard} from './CheckboxDropdownStyling';

function CheckboxDropdownStructure({footer, optionList, placement, children, onSelectAll, onDeselectAll}) {
    const {t} = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const {layerProps, renderLayer, triggerProps} = useLayer({
        isOpen: isOpen,
        placement: placement ?? 'bottom-start',
        auto: true,
        triggerOffset: 8,
        onOutsideClick: () => setIsOpen(false),
    });

    const close = () => {
        setIsOpen(false);
    };

    return (
        <CheckboxDropdownWrapper>
            <DropdownBtn type="button" onClick={() => setIsOpen(!isOpen)} {...triggerProps}>
                {children}
                <ColumnSelectionArrow />
            </DropdownBtn>
            {renderLayer(
                isOpen && (
                    <OptionCardContainer {...layerProps}>
                        <OptionCard
                            footer={footer(close)}
                            selectionBtn={
                                <>
                                    <SelectionButton link color="primary" onClick={onSelectAll} type="button">
                                        {t('generalShared.selectAll')}
                                    </SelectionButton>
                                    <SelectionButton link color="danger" onClick={onDeselectAll} type="button">
                                        {t('generalShared.deSelecttAll')}
                                    </SelectionButton>
                                </>
                            }>
                            {optionList}
                        </OptionCard>
                    </OptionCardContainer>
                ),
            )}
        </CheckboxDropdownWrapper>
    );
}

const CheckboxDropdownWrapper = styled.div`
    position: relative;
    display: inline-block;
`;

const SelectionButton = styled(Btn)`
    padding: 0 !important;
    margin: 0;
    font-size: var(--text-size-small);
    display: block;
    line-height: 0.4;
    min-height: 18px;
`;

const DropdownBtn = styled(Btn)`
    padding-right: 4px;
    min-height: 36px;
    ${btnColorSetup({
        background: 'var(--form-control-background-color)',
        border: 'var(--form-control-border-color)',
        txt: 'var(--default-text-color)',
    })};
    > ${Icon.Wrapper} svg {
        transition: 0.6s;
    }
    &:hover {
        > ${Icon.Wrapper} {
            transition: 4s;
            svg {
                transition: 0.6s;
                transform: rotate(45deg);
                color: var(--primary);
            }
        }
        ${btnColorSetup({
            background: 'var(--container-background-hover-color-300)',
            border: 'var(--primary)',
            txt: 'var(--primary)',
        })};
    }
`;

export const ColumnSelectionArrow = () => (
    <ColumnSelectionArrowWrapper>
        <Icon name="KeyboardArrowDown" />
    </ColumnSelectionArrowWrapper>
);

const ColumnSelectionArrowWrapper = styled.div`
    margin-left: 12px;
    pointer-events: none;
    display: inline-block;
`;

const OptionCardContainer = styled.div`
    z-index: 1000;
`;

export {CheckboxDropdownStructure, CheckboxDropdownWrapper, DropdownBtn};
